import { useEffect, useState, type FormEvent } from 'react';
import { useParams } from 'react-router';
import { errorMessage } from '../lib/api.js';
import { redeemGuestInvitation, signOut } from '../lib/auth.js';
import { useSession } from '../state/session.js';
import { ErrorBox } from '../components/ui.js';
import '../styles/guest-invite.css';

/**
 * Where an emailed project invitation lands (/guest-invitation/:id#secret). The secret stays in the fragment, is read
 * once and removed from the address bar, and goes to the server only in the request body.
 */
export function GuestInvitationPage() {
  const { invitationId } = useParams();
  const [secret] = useState(() => window.location.hash.slice(1));
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { user, setUser } = useSession();
  useEffect(() => { window.history.replaceState(null, '', window.location.pathname); }, []);
  const accept = async (e: FormEvent) => {
    e.preventDefault(); setBusy(true); setError(null);
    try {
      const { projectId } = await redeemGuestInvitation({ id: invitationId ?? '', secret, email: email.trim() });
      window.location.assign(`/p/${projectId}`);
    } catch (err) { setError(errorMessage(err)); setBusy(false); }
  };
  return (
    <div className="login">
      <div className="login-card">
        <img src="/apple-touch-icon.png" alt="" className="guest-accept-icon" aria-hidden="true" />
        <div className="wordmark big">Jabberr</div>
        <h1 className="guest-accept-title">Join a project</h1>
        <p className="muted">Confirm the email address this invitation was sent to. You will see this project only.</p>
        {user ? (
          <p className="small">Signed in as {user.email}. <button type="button" className="link-btn" onClick={() => void signOut().then(() => setUser(null))}>Sign out</button></p>
        ) : null}
        {!secret ? (
          <ErrorBox>Open the whole link from your invitation email. This page alone does not give access.</ErrorBox>
        ) : (
          <form className="stack" onSubmit={(e) => void accept(e)}>
            <label className="field"><span className="field-label">Invited email</span>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" autoFocus />
            </label>
            <button type="submit" className="btn btn-primary" disabled={busy || !email.trim()}>Accept invitation</button>
          </form>
        )}
        {error ? <ErrorBox>{error}</ErrorBox> : null}
      </div>
    </div>
  );
}
